module.exports = __webpack_public_path__ + "img/fca6-m.ab90fab8.png";